import type { IFieldConfiguration } from '@sravni/cosago-react-library/lib/types';

import type { TContactsFormFields } from 'entities/creditForm';

import { PhoneNumber, EmailAutocomplete } from 'features/UpdateContactsInfo/ui/fields';

export interface IContactsInfoMobileConfig extends Omit<IFieldConfiguration, 'fieldName'> {
  fieldName: keyof TContactsFormFields;
}

export const FormFieldsControls: Record<keyof TContactsFormFields, React.ReactNode> = {
  email: EmailAutocomplete,
  mobilePhone: PhoneNumber,
  userAgreement: null,
  advertisingAgreement: null,
};

export const FormFieldsNavigationSequence: IContactsInfoMobileConfig[] = [
  {
    fieldName: 'email',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'mobilePhone',
    required: true,
    checkShouldMoveToNextField: false,
  },
  {
    fieldName: 'userAgreement',
    required: true,
    checkShouldMoveToNextField: false,
  },
];
